import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "48",
  height: "49",
  viewBox: "0 0 48 49",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  y: "0.5",
  width: "48",
  height: "48",
  rx: "24",
  fill: "#E31E33"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M28.7045 17.0639C28.7045 16.8362 28.4248 16.7271 28.2706 16.8947L21.0948 24.6944C20.9474 24.8546 21.0611 25.1136 21.2788 25.1136H23.4545C24.421 25.1136 25.2045 25.8971 25.2045 26.8636V31.8386C25.2045 32.0694 25.4907 32.1769 25.6427 32.0032L31.9844 24.7555C32.1258 24.5939 32.011 24.3409 31.7962 24.3409H30.4545C29.4881 24.3409 28.7045 23.5574 28.7045 22.5909V17.0639ZM27.1667 15.8791C28.2462 14.7057 30.2045 15.4695 30.2045 17.0639V22.5909C30.2045 22.729 30.3165 22.8409 30.4545 22.8409H31.7962C33.2998 22.8409 34.1033 24.6118 33.1132 25.7433L26.7716 32.9909C25.7075 34.207 23.7045 33.4544 23.7045 31.8386V26.8636C23.7045 26.7256 23.5926 26.6136 23.4545 26.6136H21.2788C19.7546 26.6136 18.959 24.8005 19.9909 23.6788L27.1667 15.8791ZM13.25 17.2273C13.25 16.8131 13.5858 16.4773 14 16.4773H21.2727C21.6869 16.4773 22.0227 16.8131 22.0227 17.2273C22.0227 17.6415 21.6869 17.9773 21.2727 17.9773H14C13.5858 17.9773 13.25 17.6415 13.25 17.2273ZM13.25 24.5C13.25 24.0858 13.5858 23.75 14 23.75H17.6364C18.0506 23.75 18.3864 24.0858 18.3864 24.5C18.3864 24.9142 18.0506 25.25 17.6364 25.25H14C13.5858 25.25 13.25 24.9142 13.25 24.5ZM13.25 31.7727C13.25 31.3585 13.5858 31.0227 14 31.0227H20.3636C20.7779 31.0227 21.1136 31.3585 21.1136 31.7727C21.1136 32.1869 20.7779 32.5227 20.3636 32.5227H14C13.5858 32.5227 13.25 32.1869 13.25 31.7727Z",
  fill: "white"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }